import { ProductIdentifierDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

export class SearchPreviewItem {
  public productIdentifier: ProductIdentifierDto;
  public description: string | undefined;
  public thumbnail: string | undefined;

  public constructor(productIdentifier?: ProductIdentifierDto) {
    if (!productIdentifier) {
      throw new Error('Missing item reference');
    }
    this.productIdentifier = productIdentifier;
  }
}
